function initAppConfig() {
    return {
        type: "INIT_APP_CONFIG",
    }
}

export default {
    initAppConfig
}
